import React from 'react';

const InstagramIcon = (): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <path
        id="0mrswmassa"
        d="M0 8c0 4.418 3.581 8 8 8 4.419 0 8-3.582 8-8s-3.581-8-8-8C3.581 0 0 3.582 0 8zm3.867 1.622v-3.31C3.867 4.925 4.99 3.8 6.378 3.8h3.31c1.387 0 2.512 1.124 2.512 2.512v3.31c0 1.387-1.124 2.511-2.511 2.511H6.378c-1.387 0-2.511-1.124-2.511-2.511zm2.511-4.878c-.866 0-1.567.701-1.567 1.568v3.31c0 .866.701 1.568 1.567 1.568h3.31c.867 0 1.568-.702 1.568-1.568v-3.31c0-.867-.701-1.568-1.567-1.568H6.378zM9.7 5.828c0-.26.211-.471.471-.471.262 0 .472.21.472.471 0 .26-.21.472-.472.472-.26 0-.471-.212-.471-.472zM5.927 7.935c0-1.163.943-2.107 2.106-2.107 1.164 0 2.107.944 2.107 2.107 0 1.164-.943 2.108-2.107 2.108-1.163 0-2.106-.944-2.106-2.108zm.943 0c0 .643.52 1.164 1.163 1.164s1.164-.521 1.164-1.164c0-.642-.521-1.163-1.164-1.163-.642 0-1.163.52-1.163 1.163z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-500 -544) translate(260 156) translate(240 16) translate(0 234) translate(0 136) translate(0 2)">
        <use fill="#D6D6D6" xlinkHref="#0mrswmassa" />
      </g>
    </g>
  </svg>
);

export default InstagramIcon;
